import { extendsAPIServices } from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import { GET, POST } from "../../constants/HTTPConstants";

const baseAdminAffiliate = getEnv('baseAdminAffiliate');
const api = extendsAPIServices(baseAdminAffiliate);

export const _getRequestAcc = (page, limit) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/registrations?page=${page}&limit=${limit}`
    });
};

export const _requestAcc = (id, status) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/registrations/${id}/confirm`,
        data: { status }
    });
};

export const _getListUsers = (pages) => {
    const { page, limit } = pages;

    return api.makeAuthRequest({
        method: GET,
        url: `/users?page=${page}&limit=${limit}`
    });
};

export const _getListClicks = (pages) => {
    const { page, limit } = pages;

    return api.makeAuthRequest({
        method: GET,
        url: `/clicks?page=${page}&limit=${limit}`
    });
};

export const _getListConversions = (pages) => {
    const { page, limit } = pages;

    return api.makeAuthRequest({
        method: GET,
        url: `/conversions?page=${page}&limit=${limit}`
    });
};

export const _conversion = (id, status) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/conversions/${id}/confirm`,
        data: { status }
    });
};

export const _getListWithdrawal = (pages) => {
    const { page, limit } = pages;

    return api.makeAuthRequest({
        method: GET,
        url: `/withdrawals?page=${page}&limit=${limit}`
    });
};

export const _withdrawal = (id, total, paypal) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/withdrawals`,
        data: {
            receiverId: id,
            total,
            paypal
        }
    });
};

export const _changeAfiliiateStatus = (status, userId)=>{
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/status`,
        data: {
            status,
        }
    })
}

export const _getUserAffiliateStatistics = (id)=>{
    return api.makeAuthRequest({
        method: GET,
        url : `/users/${id}/statistics`,
    })
}


// WEBPACK FOOTER //
// ./src/services/apis/AdminAffiliate.js